import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

export default function Logout() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    let mounted = true;

    async function signOut() {
      try {
        await auth.logout();
      } finally {
        localStorage.removeItem("clinic_erp_token");
        localStorage.removeItem("clinic_erp_user");
        localStorage.removeItem("clinic_erp_clinic");

        if (mounted) {
          navigate("/login", { replace: true });
        }
      }
    }

    signOut();

    return () => {
      mounted = false;
    };
  }, [auth, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-hospital-bg px-4">
      <div className="rounded-xl border border-gray-200 bg-white p-8 text-center shadow-sm">
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-lg bg-hospital-primary text-white">
          <LogOut className="h-6 w-6" />
        </div>
        <h1 className="font-manrope text-xl font-bold text-hospital-text-main">
          Logging out
        </h1>
        <p className="mt-2 text-sm text-hospital-text-muted">
          Please wait, your session is closing.
        </p>
      </div>
    </div>
  );
}
